import $ from 'jquery';
import _ from 'lodash';

export default {
  init() {
    // console.log('classes');
  },
  finalize() {
    DesktopContainerWrap.init();
    ClassesOverlay.init();

  },
};

var ClassesOverlay = ( () => {
  var self = {};

  const $link = $("#classes-overlay"),
        $classes = $(".classes-block");

  self.init = () => {

    /* Hide when scrolled past classes */
    window.addEventListener('scroll', _.throttle(self.showHide, 200) );

    /* Link */
    $link.click( (e) => {
      e.stopPropagation();
      $('html, body').animate({
        scrollTop: $classes.offset().top
      }, 500);
    });

    /* Wait until images are loaded */
    $( window ).load(function() {
      self.showHide();
    });

  };

  self.showHide = () => {
    var scroll = $(window).scrollTop();
    var trigger = $classes.offset().top - $(window).height();
    console.log("scroll", scroll, "trigger", trigger, "offset", $classes.offset().top , "height", $(window).height() );
    if(scroll > trigger) {
      $link.fadeOut(200);
    }
    else {
      $link.fadeIn(200);
    }
  };

  return self;
})();

var DesktopContainerWrap = ( () =>  {
  var self = {};
  const $desktopBreakPoint = 960;

  self.init = () => {
    window.addEventListener('resize', _.throttle(self.wrapOrUnwrap, 200) );
    self.wrapOrUnwrap();
  };

  self.wrapOrUnwrap = () => {
    var w = $(window).width();
    if(w >= $desktopBreakPoint && $(".black-container").length == 0) {
      $( ".content-wrap .content-dark" ).wrapAll( "<div class='black-container' />");
      $( ".content-wrap .classes-block" ).wrapAll( "<div class='white-container' />");
    }
    else if( w <= $desktopBreakPoint && $(".black-container").length > 0) {
      $( ".content-wrap .content-dark" ).unwrap(".black-container");
      $( ".content-wrap .classes-block" ).unwrap(".white-container");
    }
  };

  return self;
})();